// src/components/BrandLoader.jsx

import logoPrincipal from '../assets/logo-principal.png';

/**
 * Um componente de loader que exibe o logo da aplicação com um spinner girando ao redor.
 * @param {{ size?: number }} props - O tamanho do loader em pixels. O padrão é 80.
 */
export function BrandLoader({ size = 80 }) {
  const logoSize = size * 0.7; // O logo será um pouco menor que o spinner

  return (
    // Contêiner relativo para posicionar o spinner e o logo
    <div 
      className="relative flex items-center justify-center"
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      {/* O Spinner (círculo que gira) */}
      <div 
        className="absolute inset-0 rounded-full border-4 border-solid animate-spin"
        style={{
          borderColor: 'rgba(59, 130, 246, 0.2)', // Cor da borda base (azul claro transparente)
          borderTopColor: 'rgb(59, 130, 246)',    // Cor da parte que "gira" (azul sólido)
        }}
      />
      
      {/* O Logo no centro */}
      <img 
        src={logoPrincipal} 
        alt="Carregando..." 
        className="object-contain"
        style={{ width: `${logoSize}px`, height: `${logoSize}px` }}
      />
    </div>
  );
}
